import { TrackingContext, type TrackingContextValue } from '@ps/web-core-analytics';
import { mapValues } from 'lodash';
import { useContext, useMemo } from 'react';

import * as trackers from '@swf/core/analytics';

type OmitContext<T> = T extends (tracking: TrackingContextValue, ...args: infer R) => void
  ? (...args: R) => void
  : never;

type Trackers = typeof trackers;

export type BoundTrackers = {
  [key in keyof Trackers]: OmitContext<Trackers[key]>;
};

const useTrackers = () => {
  const trackingContext = useContext(TrackingContext);

  return useMemo(
    () =>
      mapValues(
        trackers,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (tracker: any): OmitContext<typeof tracker> =>
          (...args) =>
            tracker(trackingContext, ...args)
      ) as BoundTrackers,
    [trackingContext]
  );
};

export default useTrackers;
